<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" right color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap 
    >
      <v-flex xs12 pt-2>
        <v-card class="mb-2" flat>
          <v-layout
            wrap
            style="font-size: 12px; font-family: poppinsregular"
            v-if="stock.length > 0"
          >
            <v-flex xs12 lg6 pa-1 v-for="(item2, i) in stock" :key="i">
              <v-card color="#e6e6e6">
                <v-layout wrap pa-4 text-left>
                  <v-flex xs6 class="shade2" px-3 py-1> Batch Number </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    {{ item2.batchNumber }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1
                    >Initial Stock
                  </v-flex>
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    <b> {{ item2.stock }}</b>
                  </v-flex>
                  <v-flex xs6 text-left class="shade2" px-3 py-1
                    >Available Stock
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    <b>
                      <span
                        :style="
                          item2.availableStock > 0 ? 'color:green' : 'color:red'
                        "
                      >
                        {{ item2.availableStock }}
                      </span>
                    </b>
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1> Price </v-flex>
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    {{ item2.price }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade2" px-3 py-1>
                    Discount(%)
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    {{ item2.discount }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1>
                    Offer Price
                  </v-flex>
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    {{ item2.offerPrice }}
                  </v-flex>

                  <v-flex xs6 text-left class="shade2" px-3 py-1>
                    Purchase Amount(₹)
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    {{ item2.purchaseAmount }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1>
                    Tax Amount(₹)</v-flex
                  >
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    {{ item2.taxAmount.toFixed(2) }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade2" px-3 py-1>
                    Tax Percentage(%)
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    {{ item2.taxPercentage.toFixed(2) }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1>
                    Manufacturing Date
                  </v-flex>
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    {{ item2.manufacturingDate.slice(0, 10) }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade2" px-3 py-1>
                    Expiry Date
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    {{ item2.expiryDate.slice(0, 10) }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade" px-3 py-1>
                    Purchase Date
                  </v-flex>
                  <v-flex xs6 text-right class="shade" px-3 py-1>
                    {{ item2.purchaseDate.slice(0, 10) }}
                  </v-flex>
                  <v-flex xs6 text-left class="shade2" px-3 py-1>
                    Shelf Life
                  </v-flex>
                  <v-flex xs6 text-right class="shade2" px-3 py-1>
                    <span v-if="item2.shelfLife"> {{ item2.shelfLife }} </span>
                  </v-flex>
                  <v-flex xs12 pb-1>
                    <v-divider
                      v-if="$route.path != '/previousStock'"
                    ></v-divider>
                  </v-flex>
                  <v-flex md6 pt-2 v-if="$route.path != '/previousStock'">
                    <v-switch
                      color="green"
                      :label="
                        item2.isCurrentStock == true
                          ? 'Active Stock'
                          : 'Inactive Stock'
                      "
                      dense
                      hide-details
                      v-model="item2.isCurrentStock"
                      @change="changeStatus(item2, val)"
                    >
                    </v-switch>
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                    pt-1
                    text-right
                    v-if="$route.path != '/previousStock'"
                  >
                    <v-btn
                      @click="openEditDialog(item2)"
                      class="mx-2"
                      fab
                      dark
                      x-small
                      color="#ff751a"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      @click="(deleteDialog = true), (deleteId = item2._id)"
                      class="mx-2"
                      style="margin-left: 5px; margin-right: 5px"
                      fab
                      dark
                      x-small
                      color="#ff751a"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout wrap v-else pt-8>
            <v-flex xs12 text-center style="font-family: poppinsbold">
              <span> No Stock Available......!</span>
            </v-flex>
          </v-layout>

          <v-layout wrap pt-3 v-if="$route.path == '/previousStock'">
            <v-flex xs12>
              <v-pagination
                :length="pages"
                :total-visible="8"
                v-model="currentPage"
                color="#FDAC53"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog width="600px" v-model="opendialog">
      <v-card
        width="600px"
        style="font-family: poppinsregular"
        v-if="newStock.discount != null"
      >
        <v-form v-model="addcat" ref="addcat">
          <v-layout wrap pa-5>
            <v-flex xs12 pb-5>
              <span v-if="stockAction == 'Add'"> Add New Stock </span>
              <span v-if="stockAction == 'Edit'"> Edit Stock </span>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Price (₹)"
                v-model="newStock.price"
                @input="chechProductTax(newStock.price, newStock.discount)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Discount (%)"
                v-model="newStock.discount"
                @input="chechProductTax(newStock.price, newStock.discount)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                disabled
                dense
                outlined
                type="number"
                label="offerPrice(₹)"
                v-model="newStock.offerPrice"
                @input="chechProductTax(newStock.price, newStock.discount)"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 lg6 px-1>
              <v-text-field
                disabled
                dense
                outlined
                type="number"
                label="Tax Amount(₹)"
                v-model="calculatedTax"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                disabled
                dense
                outlined
                type="number"
                label="Tax Percentage(%)"
                v-model="TaxPercentage"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="newStock.manufacturingDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.manufacturingDate"
                    label="Manufacturing Date "
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.manufacturingDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(newStock.manufacturingDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="newStock.expiryDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.expiryDate"
                    label="Select Expiry Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.expiryDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu1 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(newStock.expiryDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                label="Shelf Life"
                v-model="newStock.shelfLife"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Stock"
                v-model="newStock.stock"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                type="number"
                label="Purchase Amount"
                v-model="newStock.purchaseAmount"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-menu
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                :return-value.sync="newStock.purchaseDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :rules="[rules.required]"
                    dense
                    outlined
                    v-model="newStock.purchaseDate"
                    label="purchase Date "
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newStock.purchaseDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu3 = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu3.save(newStock.purchaseDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 lg6 px-1>
              <v-text-field
                :rules="[rules.required]"
                dense
                outlined
                label="Batch Number"
                v-model="newStock.batchNumber"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 text-right>
              <v-btn color="primary" text @click="AddEditStock()"> save </v-btn>
              <v-btn
                color="error"
                style="padding-left 10px"
                text
                @click="opendialog = false"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="600px" v-model="deleteDialog">
      <v-card width="600px">
        <v-layout wrap pa-1 style="font-family: poppinsregular">
          <v-flex xs12>
            <span>Do you Want to Delete this Stock...?</span>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-btn small color="primary" text @click="deleteStock()">
              Yes
            </v-btn>
            <v-btn
              small
              color="error"
              style="margin-left: 5px"
              text
              @click="deleteDialog = false"
            >
              No
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["stock", "mainVariantId", "pages", "hsnId"],
  data() {
    return {
      calculatedTax: 0,
      TaxPercentage: 0,

      // pages: 0,
      currentPage: 1,
      deleteDialog: false,
      deleteId: null,
      stockAction: "",
      addcat: false,
      menu: false,
      menu3: false,
      menu2: false,
      menu1: false,
      newStock: {},
      opendialog: false,
      appLoading: false,
      ServerError: false,
      productdata: [],
      subcategory: null,
      Category: null,
      photo: null,
      variants: [],
      stocks: [],
      snackbar: false,
      msg: "",

      rules: {
        required: (value) => !!value || "Required.",
        //  required: (value) => value == '' || "Required.",
      },
    };
  },

  mounted() {
    // this.getProduct();
  },

  watch: {
    currentPage() {
      this.$emit("stepper", { currentPage: this.currentPage });
    },
  },
  methods: {
    chechProductTax(price, discount) {
      if ((price, discount)) {
        axios({
          url: "/grocery/calculate/product/tax",
          method: "get",
          headers: {
            token: localStorage.getItem("token"),
          },
          params: {
            price: price,
            discount: discount,
            hsnId: this.hsnId,
          },
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.calculatedTax = response.data.TaxAmount.toFixed(2);
              this.TaxPercentage = response.data.TaxPercentage;
              this.newStock.offerPrice = response.data.offerPrice;
            } else {
              this.snackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },

    changeStatus(item, val) {
      console.log("item=s", item);
      console.log("val=====", val);
      axios({
        url: "/grocery/admin/replace/active/stock",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          stockId: item._id,
          productId: this.mainVariantId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.$emit("stepper", { getData: true });
            setTimeout(() => {
              this.$emit("stepper", { getData: true });
            }, 2000);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getProduct() {
      const instance = this;
      this.appLoading = true;
      axios({
        url: "/grocery/admin/varient/details",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productId: this.$route.query.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productdata = response.data.products;
          this.variants = response.data.products[0].Varients;
          let A = this.productdata[0]._id.categoryId;
          let B = this.productdata[0]._id.subcategoryId;
          this.photo = this.productdata[0].Varients[0].photo;
          this.productdata[0].Varients.map(checkout);
          function checkout(item) {
            if (item.categoryId._id == A) {
              instance.Category = item.categoryId.name;
            }
            if (item.subcategoryId._id == B) {
              instance.subcategory = item.subcategoryId.name;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    checkDiscountvariant() {
      console.log(typeof this.newStock.discount);
      if (this.newStock.discount >= 0 && this.newStock.discount < 100) {
        this.newStock.offerPrice = parseInt(
          (
            this.newStock.price -
            (this.newStock.price * this.newStock.discount) / 100
          ).toFixed(2)
        );
        console.log(" this.newStock.offerPrice ", this.newStock.offerPrice);
      } else {
        this.msg = "Please Provide valid discount";
        this.snackbar = true;
        this.newStock.offerPrice = 0;
        this.newStock.discount = 0;
      }
    },

    AddEditStock() {
      if (this.$refs.addcat.validate()) {
        let urlAdd = "/grocery/product/add/stock";
        let urlEdit = "/grocery/admin/product/edit/stock";
        let SelectedURL = null;
        if (this.stockAction == "Add") {
          SelectedURL = urlAdd;
        }
        if (this.stockAction == "Edit") {
          SelectedURL = urlEdit;
        }
        this.appLoading = true;
        axios({
          url: SelectedURL,
          method: "post",
          headers: {
            token: localStorage.getItem("token"),
          },

          data: this.newStock,
        })
          .then((response) => {
            this.appLoading = false;

            if (response.data.status) {
              this.newStock = {};
              this.opendialog = false;
              this.$emit("stepper", { getData: true });
            } else {
              this.snackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },

    openEditDialog(item) {
      console.log("edittt", item);
      this.newStock.discount = item.discount;
      this.stockAction = "Edit";
      this.newStock.price = item.price;
      console.log("item.discount==", item.discount);

      (this.calculatedTax = item.taxAmount),
        (this.TaxPercentage = item.taxPercentage),
        (this.newStock.offerPrice = item.offerPrice);
      this.newStock.manufacturingDate = item.manufacturingDate.slice(0, 10);
      this.newStock.expiryDate = item.expiryDate.slice(0, 10);
      if (item.shelfLife) {
        this.newStock.shelfLife = item.shelfLife;
      }
      this.newStock.stock = item.stock;
      this.newStock.purchaseAmount = item.purchaseAmount;
      this.newStock.purchaseDate = item.purchaseDate.slice(0, 10);
      this.newStock.batchNumber = item.batchNumber;
      this.newStock.stockId = item._id;
      this.opendialog = true;
    },

    deleteStock() {
      this.appLoading = true;
      axios({
        url: "/grocery/admin/delete/stock",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          stockId: this.deleteId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", { getData: true });
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
            this.$emit("stepper", { getData: true });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style  scoped>
.shade {
  background-color: #e6e6e6 !important ;
}
.shade2 {
  background-color: #f5f5f0 !important ;
}
</style>